import { connect } from 'react-redux'
import at from 'lodash/at'

import { fetchMessagesForWorkOrder } from '../../actions/messages'

import WorkOrderMessages from '../../components/messages/work-order-messages'

function mapStateToProps (state, ownProps) {
  const id = ownProps.workOrderId

  const workOrder = state.workOrders[id]

  if (!workOrder.messages) return { loading: true, messages: [] }

  const messages = at(state.messages, workOrder.messages || [])
  const showForm = workOrder.status === 'in_progress'

  return {
    workOrder,
    showForm,
    messages
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(fetchMessagesForWorkOrder(ownProps.workOrderId))

  return {
    onLoadNextPage () {
      dispatch(fetchMessagesForWorkOrder(ownProps.workOrderId, true))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderMessages)



// WEBPACK FOOTER //
// ./src/containers/messages/work-order-messages-container.js